import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { shouldPreserveRouteScroll } from '../../utils/routeScroll';

const scrollWindowToTop = () => {
  window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
};

const ScrollToTop = () => {
  const location = useLocation();
  const { pathname, search } = location;
  const previousPathnameRef = useRef(pathname);

  useEffect(() => {
    if (!('scrollRestoration' in window.history)) {
      return undefined;
    }

    const previousScrollRestoration = window.history.scrollRestoration;
    window.history.scrollRestoration = 'manual';

    return () => {
      window.history.scrollRestoration = previousScrollRestoration;
    };
  }, []);

  useEffect(() => {
    const previousPathname = previousPathnameRef.current;
    previousPathnameRef.current = pathname;

    if (shouldPreserveRouteScroll({ pathname, previousPathname, search })) {
      return undefined;
    }

    scrollWindowToTop();
    const animationFrameId = window.requestAnimationFrame(scrollWindowToTop);

    return () => window.cancelAnimationFrame(animationFrameId);
  }, [pathname, search]);

  return null;
};

export default ScrollToTop;
